// app/frontend/components/ui//Badges/LightCappedBadge.tsx
import React from 'react';
import { Badge } from '@mantine/core';

interface LightCappedBadgeProps {
  children: React.ReactNode;
  color?: string;
  icon?: React.ReactNode;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  style?: React.CSSProperties;
}

const LightCappedBadge: React.FC<LightCappedBadgeProps> = ({
  children,
  color = 'gray',
  icon,
  size = 'lg',
  className,
  style,
}) => {
  return (
    <Badge
      color={color}
      variant="light"
      size={size}
      leftSection={icon}
      className={className}
      style={{
        textTransform: 'capitalize',
        ...style,
      }}
    >
      {children}
    </Badge>
  );
};

export default LightCappedBadge;
